import { createRouter } from '@tanstack/react-router';
import type { IAuthContextValue } from '@/types/auth';
import { routeTree } from './routeTree.gen';

export interface IRouterContext {
  auth: IAuthContextValue;
}

export const router = createRouter({
  routeTree,
  context: {
    // placeholder — valor real injetado via RouterProvider em index.tsx
    auth: undefined!,
  },
  defaultViewTransition: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
